import * as React from 'react';
import {View, Image, PixelRatio, StyleSheet} from 'react-native';
import Styles from '../../Styles';
import type {InnerProduct} from 'src/types/ProductType';
import AVTouchableOpacity from '../AVTouchableOpacity';
import {ensureHttps} from 'src/services/StringUtils';

type ProductProps = {
  productClicked: (product: any) => void;
  style?: any;
  productStyle?: any;
  product: InnerProduct;
};

const Product = (props: ProductProps) => {
  let image = <View style={[styles.image, props.productStyle]} />;

  if (props.product.ImageUrl) {
    image = (
      <Image
        resizeMode="contain"
        style={[styles.image, props.productStyle]}
        source={{
          uri: ensureHttps(props.product.ImageUrl),
        }}
      />
    );
  }

  return (
    <View style={[styles.productsContainer, props.style]}>
      <AVTouchableOpacity
        onPress={props.productClicked}
        style={[styles.product, props.productStyle]}
        accessibilityLabel={'Product Image ' + props.product.Name}
      >
        {image}
      </AVTouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  image: {
    height: Styles.Heights.h8,
    width: Styles.Heights.h8,
  },
  product: {
    alignSelf: 'center',
    backgroundColor: Styles.white,
    height: Styles.Heights.h8,
    width: Styles.Heights.h8,
  },
  productsContainer: {
    alignItems: 'center',
    borderColor: Styles.lightGray,
    borderRadius: PixelRatio.roundToNearestPixel(4),
    borderWidth: PixelRatio.roundToNearestPixel(1),
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginHorizontal: Styles.Spacing.m1,
    overflow: 'hidden',
  },
});
export default Product;
